<template>
    <div class="obrazec obnova ovoj" id="html">
        <div class="glava">
            <div class="levi-logo">
              <img src='~@/assets/ikc.png'/>
            </div>
            <div class="desni-info">
                <p>Pivola 8, SI2311 Hoče</p>
                <p>Tel.: (02) 613 08 31, -32</p>
                <p>info@ikc-um.si</p>
                <p><a href="www.ikc-um.si">www.ikc-um.si</a></p>
            </div>
        </div>
        
        <div id="vsebina">
          <!-- razširi celice-->
           
            <div class="sekcija imeobrazca">
                <h1>Vsebina certifikata in certificiranih dejavnosti</h1>
                <h6></h6>
            </div> 
            <div class="noga-izven">
        		<div class="stevilka-strani" >E_Obr. 3.21/1, rev.00, 16. 5. 2023, stran </div>
        		<div class="info">Pivola 8, SI-2311 Hoče, telefon: + 386 (0)2 6130831, -32, e-mail: info@ikc-um.si, www.ikc-um.si</div>
      		</div>
            <form @submit.prevent="handleSubmit" class="k-form">
            
                <div class="sekcija podatki">
                    <h1>1. OSNOVNI PODATKI O NOSILCU KMG</h1>

                    <fieldset >

						
                        <label for="kontrolnastevilka" class="k-form-field">
                            <span>0) Kontrolna številka:</span>
                        </label>
						<div class="display-flex">
                            <input type="text" ref="kontrolnastevilka" name="kontrolnastevilka" id="kontrolnastevilka" class="k-textbox" />
                            
                        </div>

                        <label for="nosilec" class="k-form-field">
                            <span>a) Nosilec KMG:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" ref="nosilec" name="nosilec" id="nosilec" class="k-textbox" style="width:100%;" />
                        </div>
                        
                        <label for="ooseba" class="k-form-field">
                            <span>b) Odgovorna oseba nosilca:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" ref="ooseba"  name="ooseba" id="ooseba" class="k-textbox" style="width:100%;" />
                        </div>
                        
                        <label for="naslov" class="k-form-field">
                            <span>c) Naslov:</span>
                        </label>
                        <div class="display-flex">
                                <input type="text" ref="naslov"  name="naslov" id="naslov" class="k-textbox" style="width:100%;" />
                        </div>
                        
                        <label for="posta" class="k-form-field">
                            <span>d) Poštna številka in pošta:</span>
                        </label>
                        <div class="display-flex posta">
                            <input type="text" ref="postnastevilka"  name="postnastevilka" id="postnastevilka" class="k-textbox " />
                            <input type="text" ref="posta"  name="posta" id="nosipostalec" class="k-textbox" />
                        </div>
                        
                        <label for="kmgmid" class="k-form-field">
                            <span>e) KMG-MID:</span>
                        </label>
                            <div class="display-flex">
                            <input type="text" ref="kmgmid"  name="kmgmid" id="kmgmid" class="k-textbox" />
                        </div>
                        
                        <label for="telefon" class="k-form-field">
                            <span>f) Telefon:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" ref="telefon"  name="telefon" id="telefon" class="k-textbox" style="width:100%;"/>
                        </div>
                        
                        <label for="mobitel" class="k-form-field">
                            <span>g) Mobilni telefon:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" ref="mobitel"  name="mobitel" id="mobitel" class="k-textbox" style="width:100%;"/>
                        </div>
                        
                        <label for="email" class="k-form-field">
                        <span>h) Elektronski naslov:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" ref="email"  name="email" id="email" class="k-textbox" style="width:100%;" />
                        </div>
                        
                        <label for="spletnastran" class="k-form-field">
                            <span>i) Spletna stran KMG:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" ref="spletnastran"  name="spletnastran" id="spletnastran" class="k-textbox" style="width:100%;"/>
                        </div>
                        
                        <label for="dopolnilnadejavnost" class="k-form-field">
                            <span>l) Dopolnilna dejavnost na kmetiji:</span>
                        </label>
                        <div class="display-flex ">
                            <input class="k-checkbox" ref="dopolnilnadejavnost"  type="checkbox" name="dopolnilnadejavnost" value="da" id="dopolnilnadejavnostda">
                            <label class="form-check-label" for="dopolnilnadejavnostda" >
                            Da
                            </label>
                            <input class="k-checkbox" ref="dopolnilnadejavnost"  type="checkbox" name="dopolnilnadejavnost"  value="ne" id="dopolnilnadejavnostne">
                            <label class="form-check-label" for="dopolnilnadejavnostne" >
                            Ne
                            </label>
                        </div>
                       

                        <label for="nazivdopolnilnadejavnost" class="k-form-field">
                            <span>m) Naziv nosilca dopolnilne dejavnosti na KMG (če je drugačen kot v a):</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" ref="nazivdopolnilnadejavnost" style="width:100%;"  name="nazivdopolnilnadejavnost" id="mobinazivdopolnilnadejavnost" class="k-textbox" />
                        </div>
                        
                        <label for="davcnastevilka" class="k-form-field">
                            <span>n) Davčna številka nosilca KMG:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" ref="davcnastevilka"  name="davcnastevilka" id="davcnastevilka" class="k-textbox" />
                        </div>
                        
                    </fieldset>

                </div>
                    <div class="firstpagespace"></div>
                 <div class="sekcija dejavnosti sekcija-nb">
                    <h1>2. DEJAVNOSTI, ki jih prijavljate v postopek certificiranja </h1>
                    <fieldset class="">
                     
                    <div class="seznamdejavnosti">
                         <template v-for="vrsta in vrsta">
                            <div :key="vrsta.id" style="break-inside: avoid;">
                                
                            <template v-if="vrstapridelovalca.includes(vrsta.id)">
                                <input class="k-checkbox" checked :true-value="vrsta.id"  type="checkbox" :value="vrsta.id" :id="'vrsta_chk_'+vrsta.id">
                            </template>
                            <template v-else>
                                <input class="k-checkbox" :true-value="vrsta.id"  type="checkbox" :value="vrsta.id" :id="'vrsta_chk_'+vrsta.id">
                            </template>
                            <label class="form-check-label" :for="'vrsta_chk_'+vrsta.id" >
                            {{vrsta.naziv}}
                            </label>
                            </div>
                        </template>
                    </div>

                    </fieldset>
                </div>

                <div class="sekcija kategorije sekcija-nb">
                    <h1>3. KATEGORIJE PROIZVODOV, ki jih prijavljate v postopek certificiranja</h1>

                    <fieldset class="">
                    <div class="seznamkategorij">
                         <template v-for="kategorija in kategorije">
                            <div :key="kategorija.id" style="break-inside: avoid;">
                                <template v-if="kategorijepridelovalca.includes(kategorija.id)">
                            <input  class="k-checkbox" checked  type="checkbox" :value="kategorija.id" :id="'kat_chk_'+kategorija.id">
                            </template>
                            <template v-else>
                                <input  class="k-checkbox"  type="checkbox" :value="kategorija.id" :id="'kat_chk_'+kategorija.id">
                            </template>
                            <label class="form-check-label" :for="'kat_chk_'+kategorija.id" >
                            ({{kategorija.id}}) {{kategorija.naziv}}
                            </label>
                            </div>
                        </template>
                         <div>Proizvodi iz kategorije g:</div>
                            <fieldset class="">
                            <textarea rows="2" style="width:100%;"></textarea>
                    </fieldset>

                    </div>

                    </fieldset>
                </div>

                <div class="sekcija  sekcija-nb posebnosti">
                    <h1>4. POSEBNOSTI</h1>

                    <fieldset class="">
                    <div >
                         <template v-for="posebnost in posebnosti">
                            <div :key="posebnost.id" style="break-inside: avoid;">
                            <input  class="k-checkbox"  type="checkbox" :value="posebnost.id" :id="'pos_chk_'+posebnost.id">
                            <label class="form-check-label" :for="'pos_chk_'+posebnost.id" >
                            {{posebnost.naziv}}
                            </label>
                            </div>
                        </template>
                         <div>Drugo:</div>
                    <fieldset class="">
                    <textarea rows="1" style="width:100%;"></textarea>
                    </fieldset>
                    </div>

             

                    <div>
                        <div>IZVAJANJE DEJAVNOSTI ZA TRETJE OSEBE NA KMG (uslužnostna predelava npr. mletje, luščenje, skladiščenje…)</div>
                         <template v-for="to in tretjeosebe">
                            <div :key="to.id" style="break-inside: avoid;">
                            <input  class="k-checkbox"  type="checkbox" :value="to.id" :id="'to_chk_'+to.id">
                            <label class="form-check-label" :for="'to_chk_'+to.id" >
                            {{to.naziv}}
                            </label>
                            </div>
                        </template>
                    </div>

                    </fieldset>
                </div>

                <div class="sekcija spremmembe sekcija-pb1" style="break-inside: avoid;">
                    <h1>5. NEEKOLOŠKE DEJAVNOSTI</h1>
                    <!--<div>Na obrazcu označite in spremenite samo tiste podatke, ki se spreminjajo. Poljščine se posodabljajo z zbirno vlogo.</div>-->
                    <fieldset class="">
                    <textarea  rows="3" style="width:100%;"></textarea>
                    </fieldset>
                </div>
				<div class="sekcija spremmembe sekcija-pb1" style="break-inside: avoid;">
                    <h1>6. PODIZVAJALCI</h1>
                    <!--<div>Na obrazcu označite in spremenite samo tiste podatke, ki se spreminjajo. Poljščine se posodabljajo z zbirno vlogo.</div>-->
                    <fieldset class="">
                    <textarea  rows="3" style="width:100%;"></textarea>
                    </fieldset>
                </div>

                <div class="sekcija spremmembe sekcija-pb1" style="break-inside: avoid;">
                    <h1>7. TRŽENJE</h1>
                    <!--<div>Na obrazcu označite in spremenite samo tiste podatke, ki se spreminjajo. Poljščine se posodabljajo z zbirno vlogo.</div>-->
                    <fieldset class="">
                    <textarea  rows="3" style="width:100%;"></textarea>
                    </fieldset>
                </div>

				

				<div class="sekcija kulture zacetek-strani">
                    <h1>8. ŽIVALI</h1>
                    <div class="tabela-kultura-wrapper">
						<table class="tabela">
							<colgroup>
    							<col style="width:43%">
    							<col style="width:10%">
								<col style="width:12%">
								<col style="width:11%">
                                <col style="width:24%">
  							</colgroup>
							<tr>
							<th>Naziv</th>
							<th>Št.</th>
							<th>Prosta / vezana reja</th>
							<th>Paša</th>
                            <th>Status</th>
						</tr>
						<tr>
							<th>Naziv</th>
							<th>Št.</th>
							<th>Prosta / vezana reja</th>
							<th>Paša</th>
                            <th>Status</th>
						</tr>
						</table>
						</div>
						
						<div class="tabela-kultura-wrapper">
						<table class="tabela" >
							<colgroup>
    							<col style="width:43%">
    							<col style="width:10%">
								<col style="width:12%">
								<col style="width:11%">
                                <col style="width:24%">
  							</colgroup>
							<tr v-for="(zival,i) in zivali">
								<td>{{ zival.skupina==zival.naziv?"":(zival.skupina+": ") }}{{ zival.naziv }}</td>
								<td>{{ zival.stevilo }}</td>
								<td></td>
								<td>Da/Ne</td>
                                <td>{{ zival.status }}</td>
							</tr>
							
							
						</table>
					</div>
                    

                </div>

                <div class="sekcija kulture zacetek-strani">
                    <h1>9. KULTURE</h1>
                    <div class="tabela-kultura-wrapper">
						<table class="tabela">
							<colgroup>
    							<col style="width:50%">
    							<col style="width:11%">
								<col style="width:14%">
								<col style="width:25%">
  							</colgroup>
							<tr>
								<th>Naziv</th>
								<th>Pov (a)</th>
								<th>Količina</th>
								<th>Status</th>
							</tr>
							<tr>
								<th>Naziv</th>
								<th>Pov (a)</th>
								<th>Količina</th>
								<th>Status</th>
							</tr>
							
						</table>
					</div>	
					<div class="tabela-kultura-wrapper">
						<table class="tabela">
							<colgroup>
    							<col style="width:50%">
    							<col style="width:11%">
								<col style="width:14%">
								<col style="width:25%">
  							</colgroup>
							<tr v-for="(kultura,i) in kulture">
								<td>{{ kultura.naziv }} ({{ kultura.skupina }})</td>
								<td>{{kultura.povrsina}}</td>
								<td>{{kultura.kolicina}}</td>
								<td>{{kultura.status}}</td>
							</tr>
                            <tr v-for="index in (kulture.length%2==1?5:4)">
								<td>&nbsp;</td>
								<td>&nbsp;</td>
								<td>&nbsp;</td>
								<td>&nbsp;</td>
							</tr>
						
							
							
						</table>
						
                    </div>
                    

                </div>

				<div class="sekcija kulture">
                    <h1>10. PROIZVODI</h1>
                    <div class="tabela-kultura-wrapper">
						<table class="tabela" >
							<colgroup>
    							<col style="width:55%">
    							<col style="width:20%">
								<col style="width:25%">
  							</colgroup>
							<tr>
							<th>Naziv</th>
							<th>Količina</th>
							<th>Status</th>

						</tr>
						<tr>
							<th>Naziv</th>
							<th>Količina</th>
							<th>Status</th>

						</tr>
						
						</table>
					</div>
					<div class="tabela-kultura-wrapper">
						<table class="tabela" >
							<colgroup>
    							<col style="width:55%">
    							<col style="width:20%">
								<col style="width:25%">
  							</colgroup>
							<tr v-for="(proizvod,i) in proizvodi">
								<td>{{ proizvod.naziv }}: {{ proizvod.naziv_interno }}</td>
								<td>{{ proizvod.kolicina }}</td>
								<td>{{ proizvod.status }}</td>
							
							</tr>
							
							<tr v-for="i in (proizvodi.length%2==1?5:4)">
								<td>&nbsp;</td>
								<td></td>
								<td></td>
								
							</tr>
						</table>
						
                      
                    </div>
                    

                </div>
            
                <div class="noga-noter">
					<div class="datum">
	           Datum
			</div>
			<div class="podpis">
				Podpis izvajalca

			</div>
			
            <div class="podpis">
				Podpis kontrolorja

			</div>
			
         		</div>
				

            </form>
        </div>
        <!-- <div class="noga">
            <div class="info">IKC UM</div>
            <div class="stevilka-strani"></div>
        </div> -->
    </div>
</template>
<style scoped>

  h1,h2,h3{
    font-size:5mm;
    line-size:5mm;
  }

@media print {
.sekcija-nb {
    break-inside: avoid!important;
        }
}

.noga-noter {

display:    flex ;
flex-direction:     row ;
justify-content:    space-between;
margin-top:1rem;
}

.datum,.podpis {
	flex:1 1 33%;
	font-size: 1rem;
    padding-top:2rem;
    text-align: center;
    border:1px solid green;
}


.tabela-kultura-wrapper {
	column-count:2;
    
    
}
.tabela-proizvod-wrapper {
	column-count:3;
    
}
.tabela{
	width: 100%;
	table-layout: fixed;
}
.tabela th {
    font-size: 0.5rem;
}


.tabela td,.tabela,.tabela th {
	
	border: 1px solid green;
	border-collapse: collapse;
	padding:3px;
    font-size: 0.7rem;
}

 label,textarea{
    break-inside: avoid !important;
     
 }
.glava{
    
    display:    flex ;
    flex-direction:     row ;
    justify-content:    space-between  ;

}
.levi-logo  {
   position:   running(obrazecLeviLogo); 
}  

.levi-logo img{
    height: 2cm;
  
}
.desni-info {
    position:   running(obrazecDesniInfo);
}

.desni-info p{
    
    margin: 0;
    font-size:  0.4cm;
    line-height:   0.4cm;
    text-align:     right   ;
}



 .noga {

    position:   running(obrazecNoga);
    font-size: 3mm ;
    line-height:5mm;
    display:    flex ;
    flex-direction:     row ;
    justify-content:    space-between;
}

 .stevilka-strani:after{
  content: counter(page) " od " counter(pages);
}


label.k-form-field{
    font-weight:    bold;
    font-size:  0.8em;
    line-height:    0.8em;
    margin-top:2mm;
    margin-bottom:1mm;
}
.posta input:nth-child(1){
    flex-basis: 15%;
    margin-right: 3mm;

}
h6{
    font-size: 0.7em;
}

.sekcija {
    margin-top:5mm;
    border:   1px solid green;
    padding: 2mm;
   
}
.sekcija-pb1 {
    padding-bottom:1mm;
}

.posebnosti .seznamkategorij
{
    border-bottom:  1px solid green;
}
.izjava ul{
    list-style-type: disc;
margin-top: 3mm;
margin-bottom: 3mm;
margin-left: 0;
margin-right: 0;
padding-left: 10mm;
}
.vrsticapodpisa div {
    flex-basis: 50%;
}
.noga-izven{
  position:  running(nogaRunning);
  font-size: 3mm ;
  line-height:5mm;
 
}

.zacetek-strani {
  break-before: always;
}

@page {

margin-top: 10mm;
margin-bottom: 20mm;
margin-left: 10mm;
margin-right: 10mm;
size: A4 portrait;

@bottom-center {
content:  element(nogaRunning);
vertical-align: top;
}

}
</style>

<script>



import { mapState, mapActions,mapMutations } from 'vuex'
import { Previewer,registerHandlers,Handler  } from 'pagedjs';


class RepeatingTableHeaders extends Handler {
 
    constructor(chunker, polisher, caller) {
        super(chunker, polisher, caller);
        this.splitTablesRefs = [];
    }

    afterPageLayout(pageElement, page, breakToken, chunker) {
        this.chunker = chunker;
        this.splitTablesRefs = [];

        if (breakToken) {
            const node = breakToken.node;
            const tables = this.findAllAncestors(node, "table");
            if (node.tagName === "TABLE") {
                tables.push(node);
            }

            if (tables.length > 0) {
                this.splitTablesRefs = tables.map(t => t.dataset.ref);

                //checks if split inside thead and if so, set breakToken to next sibling element
                let thead = node.tagName === "THEAD" ? node : this.findFirstAncestor(node, "thead");
                if (thead) {
                    let lastTheadNode = thead.hasChildNodes() ? thead.lastChild : thead;
                    breakToken.node = this.nodeAfter(lastTheadNode, chunker.source);
                }

                this.hideEmptyTables(pageElement, node);
            }
        }
    }

    hideEmptyTables(pageElement, breakTokenNode) {
        this.splitTablesRefs.forEach(ref => {
            let table = pageElement.querySelector("[data-ref='" + ref + "']");
            if (table) {
                let sourceBody = table.querySelector("tbody > tr");
                if (!sourceBody || this.refEquals(sourceBody.firstElementChild, breakTokenNode)) {
                    table.style.visibility = "hidden";
                    table.style.position = "absolute";
                    let lineSpacer = table.nextSibling;
                    if (lineSpacer) {
                        lineSpacer.style.visibility = "hidden";
                        lineSpacer.style.position = "absolute";
                    }
                }
            }
        });
    }

    refEquals(a, b) {
        return a && a.dataset && b && b.dataset && a.dataset.ref === b.dataset.ref;
    }

    findFirstAncestor(element, selector) {
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                return element.parentNode;
            }
            element = element.parentNode;
        }
        return null;
    }

    findAllAncestors(element, selector) {
        const ancestors = [];
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                ancestors.unshift(element.parentNode);
            }
            element = element.parentNode;
        }
        return ancestors;
    }

    // The addition of repeating Table Headers is done here because this hook is triggered before overflow handling
    layout(rendered, layout) {
        this.splitTablesRefs.forEach(ref => {
            const renderedTable = rendered.querySelector("[data-ref='" + ref + "']");
            if (renderedTable) {
                // this event can be triggered multiple times
                // added a flag repeated-headers to control when table headers already repeated in current page.
                if (!renderedTable.getAttribute("repeated-headers")) {
                    const sourceTable = this.chunker.source.querySelector("[data-ref='" + ref + "']");
                    this.repeatColgroup(sourceTable, renderedTable);
                    this.repeatTHead(sourceTable, renderedTable);
                    renderedTable.setAttribute("repeated-headers", true);
                }
            }
        });
    }

    repeatColgroup(sourceTable, renderedTable) {
        let colgroup = sourceTable.querySelectorAll("colgroup");
        let firstChild = renderedTable.firstChild;
        colgroup.forEach((colgroup) => {
            let clonedColgroup = colgroup.cloneNode(true);
            renderedTable.insertBefore(clonedColgroup, firstChild);
        });
    }

    repeatTHead(sourceTable, renderedTable) {
        let thead = sourceTable.querySelector("thead");
        if (thead) {
            let clonedThead = thead.cloneNode(true);
            renderedTable.insertBefore(clonedThead, renderedTable.firstChild);
        }
    }

    // the functions below are from pagedjs utils/dom.js
    nodeAfter(node, limiter) {
        if (limiter && node === limiter) {
            return;
        }
        let significantNode = this.nextSignificantNode(node);
        if (significantNode) {
            return significantNode;
        }
        if (node.parentNode) {
            while ((node = node.parentNode)) {
                if (limiter && node === limiter) {
                    return;
                }
                significantNode = this.nextSignificantNode(node);
                if (significantNode) {
                    return significantNode;
                }
            }
        }
    }

    nextSignificantNode(sib) {
        while ((sib = sib.nextSibling)) {
            if (!this.isIgnorable(sib)) return sib;
        }
        return null;
    }

    isIgnorable(node) {
        return (node.nodeType === 8) || // A comment node
            ((node.nodeType === 3) && this.isAllWhitespace(node)); // a text node, all whitespace
    }

    isAllWhitespace(node) {
        return !(/[^\t\n\r ]/.test(node.textContent));
    }

}

registerHandlers(RepeatingTableHeaders);



import { Input } from '@progress/kendo-vue-inputs';
import  kultureseznam  from './support/kulture-certificiranje';
import Vue from 'vue';

export default {
    components: {
    KInput: Input,
  },
    props: ["pridelovalecid","sezona","shema"],
   data() {
        return {
            posebnosti:[{id:0,naziv:"sočasna ekološka in neekološka pridelava/reja/predelava"},{id:1,naziv:"gobe"},{id:2,naziv:"vzgoja sadik"},{id:3,naziv:"samonikle rastline"},{id:4,naziv:"čebele"},{id:5,naziv:"pridelava semena"}],
            blagovneznamke:[{id:1,naziv:"DEMETER"},{id:2,naziv:"V-Label"},{id:3,naziv:"brez GSO"}],
            tretjeosebe:[{id:1,naziv:"Samo eko predelava"},{id:2,naziv:"samo konv. predelava"},{id:3,naziv:"eko in konv predelava"},],
            kulture:[],zivali:[],proizvodi:[],
            vrsta:[],
            status:[],
            pridelava:{},
            statuskategorije:[],
            kategorije:[],
			kontrolnastevilka:"",
            nosilec:"test",
            ooseba:"",
            naslov:"",
            posta:"",
            postnastevilka:"",
            kmgmid:"",
            telefon:"",
            mobitel:"",
            email:"",
            spletnastran:"",
            naslovkmg:"",
            postakmg:"",
            postnastevilkakmg:"",
            dopolnilnadejavnost:"",
            davcnastevilka:"",
            nazivdopolnilnadejavnost:""
        }
    },
    computed:{
      ...mapState({certifikat(state) {
      
          return state.certifikat.certifikat;
        }}),
       ...mapState('pridelava', ['pridelovalec']),
        ...mapState('sifrant', ['sifrant','dataSezone']),
        /*...mapState({proizvodi(state) {
          return state.proizvod.proizvod;
        }}),*/
        

      kategorijepridelovalca:
        {
           get() {

            
            let pridelava=this.pridelovalec?.sheme?.find(s=>s.sezona==this.dataSezona.sezona-1&&s.shema=="EKO PRI");
            let kategorije=pridelava?.kategorije
            if (kategorije){
                return kategorije.map(i=>(i.id));
            }
            else
                return ["a"];

          },
        },
     vrstapridelovalca:
        {
           get() {
            let pridelava=this.pridelovalec?.sheme?.find(s=>s.sezona==this.dataSezona.sezona-1&&s.shema=="EKO PRI");
            
            let dejavnost=pridelava?.dejavnosti
                 
              
            if (dejavnost)
                return dejavnost.map(i=>(i.id));
            else
                return [];

          }
        },
 vrstapridelovalcavse:
        {
           get() {

            let pridelava=this.pridelovalec?.sheme?.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.vsedejavnosti;
            else
                return [];

          }
        },
		/*
        proizvodi:
        {
           get() {
            if(!this.certifikat.vsiproizvodi)
              return [];
            else
              return this.certifikat.vsiproizvodi.filter(i=>i.statuspridelkanaziv!='Neekološki').sort(
                (a,b)=>
                {
                  var x=a.vrstapridelkaid-b.vrstapridelkaid;
                  if(x)
                  return x;
                  else
                  {

                    return a.certifikat.localeCompare(b.certifikat);
                  }
                });
            
          },
        }
		*/
    
    },
     methods: {

        ...mapActions('certifikat', ['vrniPoId']),
          ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapActions('pridelava',['loadOne','save','loadIdPoSezoni']),
        ...mapActions('proizvod', ['load','save','loadPreteklaSezona']),
         ...mapMutations('pridelava',['updateprop','updateshemaprop']),
                handleSubmit(e){

          e.preventDefault();
        },
        print() {
                let paged = new Previewer();
                paged.preview();
        },
        naloziPodatke (){

         var thisComp=this;
         var psifranti=[
         this.naloziSifrant({sezona:this.dataSezona.sezona-1,sifrant:"zival"}),
         this.naloziSifrant({sezona:this.dataSezona.sezona-1,sifrant:"kultura"}),
         this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"vrstapridelovalca"}),
         this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"statuspridelovalca"}),
         this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"kategorije"}),
         
         ]
        Promise.all(psifranti).then(()=>{
            thisComp.vrsta=thisComp.sifrant["vrstapridelovalca"];
            thisComp.status=thisComp.sifrant["statuspridelovalca"];
            thisComp.kategorije=thisComp.sifrant["kategorije"];
            let sifrantkulture=this.sifrant["kultura"];
            let sifrantzivali=this.sifrant["zival"];
                     this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(p=>{

                            console.log(p);
                            thisComp.kmgmid=p.kmgmid;

							var kontakt=p.kontakt.find(k=>k.vloga=="nosilec kmg");
      						if(!kontakt)
      						kontakt=p.kontakt.find(k=>k.glavni);
      						if(!kontakt)
      						kontakt=p.kontakt[0];

                              thisComp.nosilec=kontakt.naziv;
                           // thisComp.ooseba=p.kontakt[0].naziv;
                            thisComp.naslov=kontakt.naslov;
                            thisComp.posta=kontakt.posta;
                            thisComp.postnastevilka=kontakt.postnastevilka;
                            thisComp.telefon=p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.telefon.join(";");
                            thisComp.email=kontakt.email.join(", ");
                            thisComp.mobitel=kontakt.telefon.join(", ");
                            thisComp.naslovkmg=p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.naslov;
                            thisComp.postakmg=p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.posta
                            thisComp.postnastevilkakmg  =p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.postnastevilka;
                            thisComp.davcnastevilka =p.davcnastevilka  ;
                            
                            thisComp.$refs.kmgmid.setAttribute("value",thisComp.kmgmid);
                            thisComp.$refs.nosilec.setAttribute("value",thisComp.nosilec);
                            thisComp.$refs.naslov.setAttribute("value",thisComp.naslov);
                            thisComp.$refs.posta.setAttribute("value",thisComp.posta);
                            thisComp.$refs.postnastevilka.setAttribute("value",thisComp.postnastevilka);
                            thisComp.$refs.telefon.setAttribute("value",thisComp.telefon);
                            thisComp.$refs.email.setAttribute("value",thisComp.email);
                            thisComp.$refs.mobitel.setAttribute("value",thisComp.mobitel);
                            //thisComp.$refs.naslovkmg.setAttribute("value",thisComp.naslovkmg);
                            //thisComp.$refs.postakmg.setAttribute("value",thisComp.postakmg);
                            //thisComp.$refs.postnastevilkakmg  .setAttribute(thisComp.postnastevilkakmg);
                            thisComp.$refs.davcnastevilka.setAttribute("value",p.davcnastevilka)
							

                          let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
                            if (pridelava) {
                        
                            thisComp.pridelava  =pridelava  ;
                            thisComp.kontrolnastevilka=pridelava.kontrolnaStevilka;
                            //thisComp.$refs.kontrolnastevilka.value=pridelava.kontrolnaStevilka;
                            thisComp.$refs.kontrolnastevilka.setAttribute("value",pridelava.kontrolnaStevilka);

                            }
                            let lanskapridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona-1&&s.shema=="EKO PRI");
                            if(lanskapridelava){

                            }
                          
                            
                        
                        var pdata=[
                        this.load({sezona:(this.dataSezona.sezona-1),pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"kultura"}).then(

                                data=>{
                                   

                                   
                                    thisComp.kulture=kultureseznam.map(i=>{
                                        
                                        let kultura=sifrantkulture.find(s=>s.naziv==i.naziv&&s.skupinakulture==i.skupina&&s.certifikat!="/");

                                        let lanskipodatki=data.find(d=>d.kulturaid==kultura?.id)
                                        return {
                                        obstaja:lanskipodatki?true:false,
                                        naziv:i.naziv,
                                        skupina:i.skupina,
                                        status:lanskipodatki?.statuspridelkanaziv,
                                        povrsina:lanskipodatki?.povrsina,
                                        kolicina:lanskipodatki?.kolicina,
                                        vrsta:"kultura"}
                                    }).filter(d=>d.obstaja).sort((a,b)=>a.naziv.localeCompare(b.naziv))

                                   // thisComp.kulture=data.map(i=>{return {naziv:i.naziv,status:i.statuspridelkanaziv,vrsta:"kultura"}})
                                    
                                },
                                error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
                        ),
                        this.load({sezona:(this.dataSezona.sezona-1),pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"zival"}).then(

                                data=>{
                                    
                                    
                                    thisComp.zivali=sifrantzivali.map(i=>{
                                    let lanskipodatki=data.find(d=>d.zivalid==i.id);
                                        return {
                                        naziv:i.naziv,
                                        status:lanskipodatki?.statuspridelkanaziv,
                                        stevilo:lanskipodatki?.stevilo,
                                        skupina:i.skupinazivali,
                                        vrsta:"zival"}
                                    }).sort((a,b)=>{
                                        return (a.skupina.localeCompare(b.skupina)==0?a.naziv.localeCompare(b.naziv):a.skupina.localeCompare(b.skupina));
                                    })
                                        
                                    //data.map(i=>{return {naziv:i.naziv,status:i.statuspridelkanaziv,vrsta:"zival"}})
                                    
                                },
                                error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
                        ),
                        this.load({sezona:(this.dataSezona.sezona-1),pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"proizvod"}).then(

                                data=>{
                                    
                                    thisComp.proizvodi=data.map(i=>{return {
                                        naziv:i.naziv,
                                        kolicina:i.kolicina,
                                        
                                        status:i.statuspridelkanaziv,naziv_interno:i.naziv_interno,vrsta:"proizvod",kategorija:i.kategorija}}).sort((a,b)=>a.naziv.localeCompare(b.naziv))
                                    
                                //this.$nextTick(function () {
                                    //let paged = new Previewer();
                                    //paged.preview();
                                //});
                                },
                                error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
                        )]



                        Promise.all(pdata).then(v=>{
						let paged = new Previewer();
      			        paged.preview();
                        //naredi for skozi celi šifrant kultur in živali
                        
					})
 

                }) ;
      
        


        });
   
        
    }                
    

      },
    created()
  {
    
    
    if(!this.sezona)
        this.dataSezona={sezona:2022};
    else
      this.dataSezona={sezona:this.sezona};

     this.naloziPodatke();
     //window.addEventListener('beforeprint',this.print);
},

  mounted(){
   
 }
}
</script>